import * as React from 'react';
import { LinkButton, Icons } from 'components';

export interface IComparisonItemProps {
    name: string;
    icon: string;
    onRemoveClick: () => any;
}
export interface IComparisonItemState {}

/* eslint-disable @typescript-eslint/indent */
class ComparisonItemComponent extends React.Component<
    IComparisonItemProps,
    IComparisonItemState
> {
/* eslint-enable @typescript-eslint/indent */

    constructor(props: IComparisonItemProps) {
        super(props);
    }

    render() {
        let { name, icon } = this.props;
        return (
            <div className="comparison-object-item">
                <div className="object-icon">
                    <img src={icon} />
                </div>
                <div
                    className="object-name"
                    dangerouslySetInnerHTML={{
                        __html: name
                    }}
                />
                <div className="delete-icon">
                    <LinkButton
                        onClick={this.props.onRemoveClick}
                        icon={<Icons.IconGarbageBin />}
                    />
                </div>
            </div>
        );
    }
}

export const ComparisonItem = ComparisonItemComponent;
